module.exports = __webpack_public_path__ + "static/media/twelve_monkeys_kitchen.8399a087.png";